import SocialHistoryForm from './SocialHistoryForm';
import {save} from '../../app-components/action/SaveAction';
import {cancelButton} from '../../app-components/action/CloseAction';
let header = {
  title: 'Add Social History',
  actions: [cancelButton(), save()],
};

export default SocialHistoryForm({header});
